const setDefaultCampaignBudgets = form => {
  form.insertionOrderBudgets.forEach(insertionOrderBudget => {
    form.campaign.addCampaignBudget(insertionOrderBudget, {
      budget: insertionOrderBudget.summary.budget,
    })
  })
}

export default setDefaultCampaignBudgets
